import styled from 'styled-components'

const PolicyRuleMessageWrapper = styled.div`
  &:not(:empty) {
    margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
  }
`

export default PolicyRuleMessageWrapper
